export const featuredPortfolio = [
    {
      id: 1,
      title: "Simple Banking System",
      img:
        "https://www.totaltrainingsolutions.com/wp-content/uploads/2015/10/bank-processing-eLearning_Fotolia_88416727_Subscription_Monthly_M.jpg",
        link:"https://github.com/s-chandr/Simple-Banking-System-",
    },
    {
      id: 2,
      title: "Web Calender",
      img: "https://img.freepik.com/free-vector/calendar-deadline-with-check-clock-flat-design_115464-604.jpg?size=626&ext=jpg",
        link:"https://github.com/s-chandr/Web-Calender",
    },
    {
      id: 3,
      title: "Weather App",
      img:
        "https://i.ibb.co/vHW4ZF4/Screenshot-368.png",
        link:"https://github.com/s-chandr/Weather-Api",
    },
    {
      id: 4,
      title: "Portfilio Website",
      img:
        "https://i.ibb.co/B6snfTm/Screenshot-369.png",
        link:"https://github.com/s-chandr/Portfolio",
    },
    {
      id: 5,
      title: "Expense Tracker",
      img:
        "https://i.ibb.co/xJJT3sk/transaction-tracker.png",
        link:"https://github.com/s-chandr/ExpenseTracker",
    },
    
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "Flask Weather App",
      img: "https://i.ibb.co/vHW4ZF4/Screenshot-368.png",
        link:"https://github.com/s-chandr/Weather-Api",
    },
    {
        id: 2,
        title: "Portfilio Website",
        img:
          "https://i.ibb.co/B6snfTm/Screenshot-369.png",
          link:"https://github.com/s-chandr/Portfolio",
    },
    {
      id: 3,
      title: "Blog-Django",
      img: "https://i.ibb.co/Jzd7swj/blog.png",
        link:"https://github.com/s-chandr/Blog-Django",
    },
    {
      id: 4,
      title: "Expense Tracker",
      img:
        "https://i.ibb.co/xJJT3sk/transaction-tracker.png",
        link:"https://github.com/s-chandr/ExpenseTracker",
    },
    
  ];
  
  export const systemPortfolio = [
    {
      id: 1,
      title: "Simple Banking System",
      img:
        "https://www.totaltrainingsolutions.com/wp-content/uploads/2015/10/bank-processing-eLearning_Fotolia_88416727_Subscription_Monthly_M.jpg",
        link:"https://github.com/s-chandr/Simple-Banking-System-",
    },
    {
      id: 2,
      title: "Bill-Gen",
      img:
        "https://graphictutorials.net/wp-content/uploads/2020/06/screen-0-scaled.jpg",
        link:"https://github.com/s-chandr/Bill-Gen/tree/main",
    },
  ];
  
  
  
